import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { PRICE } from '../constants/content';
import { PriceDisplay } from './PriceDisplay';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-crimson-dark py-14 text-white sm:py-20" data-id="element-60" data-mp="19cunm2d40so6">
      <div className="mx-auto max-w-3xl px-4" data-id="element-61" data-mp="15ckg2l9o5u77">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-62" data-mp="1jd51lp6yy44e">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-gold bg-gold/15 px-4 py-1.5 text-sm font-700 uppercase tracking-widest text-gold-light" data-id="element-63" data-mp="1o43hino1p074">
            <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-64" data-mp="221a4kufsxl25" />
            La oferta está por terminar
          </div>
          <h2 className="font-display text-3xl font-700 leading-tight sm:text-4xl" data-id="element-65" data-mp="n5uma2yndpha">
            La Oferta Especial de Lanzamiento Está Por Terminar
          </h2>

          <div className="mt-5 space-y-4 text-base leading-relaxed text-gray-200" data-id="element-66" data-mp="s6s1q7s9w5f3">
            <p data-id="element-67" data-mp="x27f6ymdbzaz">
              Te aviso: esta oferta especial de lanzamiento se va a cerrar
              pronto y no vas a poder entrar a este precio después de eso,
              aunque quieras.
            </p>
            <p data-id="element-68" data-mp="162dyj14qzti2">
              Porque Pollería Rentable 2026 pronto va a costar{' '}
              <PriceDisplay amount={PRICE.next} className="font-700 text-white" data-id="element-69" data-mp="1b1ytz1kpljq1" />
              .
            </p>
            <p data-id="element-70" data-mp="1ktwcyuhylfzb">
              Pero ACÁ, en ESTA página, el precio es un pago único de solo{' '}
              <PriceDisplay amount={PRICE.today} className="font-700 text-gold-light" data-id="element-71" data-mp="1psze43utj220" />
              . Y esta página va a desaparecer muy pronto.
            </p>
            <p data-id="element-72" data-mp="3qtvzej24veiv">
              En cuanto compres, tenés{' '}
              <strong className="font-700 text-white" data-id="element-73" data-mp="3qsb0kh8sd9f7">
                ACCESO INSTANTÁNEO
              </strong>{' '}
              a todos los videos, calculadoras y bonos. No hay que esperar
              ningún envío — podés empezar a mirar el primer módulo en los
              próximos minutos.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-8 rounded-2xl border-2 border-gold bg-ink/40 p-6 text-center sm:p-8" data-id="element-74" data-mp="deprd65zk7sw">
          <p className="text-sm font-600 uppercase tracking-widest text-gold-light" data-id="element-75" data-mp="2o8c6ejzb871t">
            Precio de hoy
          </p>
          <PriceDisplay amount={PRICE.today} className="mb-5 block font-display text-6xl font-700 leading-none text-gold-light sm:text-7xl" symbolClassName="mr-1 align-top text-4xl" data-id="element-76" data-mp="2k8l9rzn3qwpd" />
          <CtaButton data-id="element-77" data-mp="20d0gwc3ic4td">COMPRAR AHORA</CtaButton>
          <p className="mt-4 text-xs text-gray-300" data-id="element-78" data-mp="20bz1jvfgkw5u">
            Esto es un pago único. No hay cuotas mensuales ni costos ocultos. Me
            reservo el derecho de terminar este descuento en cualquier momento
            sin previo aviso después del 9 de agosto de 2026.
          </p>
        </motion.div>

        {/* P.D. */}
        <div className="mt-8 space-y-4 border-l-4 border-gold pl-4 text-sm leading-relaxed text-gray-200" data-id="element-79" data-mp="1hdmhvfqx83w0">
          <p data-id="element-80" data-mp="1mcpkyuncc01c">
            <strong className="font-700 text-gold-light" data-id="element-81" data-mp="1mc7kfltnaznm">P.D.:</strong> Recordá
            que contás con mi Garantía de 30 Días 100% Sin Riesgo. Estoy seguro
            de que vas a estar más contento que un domingo con la parrilla
            prendida y la pollería llena. Pero si por cualquier motivo no es
            así, no hay drama: tu inversión está protegida por 30 días
            completos.
          </p>
          <p data-id="element-82" data-mp="1bqfuni1nh5ca">
            <strong className="font-700 text-gold-light" data-id="element-83" data-mp="1bpxnvrhd38q4">P.D.2:</strong> Esta es
            una oferta POR TIEMPO LIMITADO. Nunca más vas a tener la oportunidad
            de acceder a este sistema a este precio una vez que termine el
            lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}